export default __webpack_public_path__ + "static/media/checkerboard.186ca139.svg";